import {WicketUser} from '@tisa-group/models';

export class LoadWicketUser {
  static readonly type = '[User] Fetch user';
}

export class SetWicketUser {
  static readonly type = '[User] Set user';

  constructor(readonly user: WicketUser | null | undefined) {}
}
